import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoginFooter from "./LoginFooter";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../Alert";
import logo from '../../images/LOGO.png';
import { loginUser } from "../../Actions/AuthAction";
import TitleBar from "../TitleBar";
import { appName } from "../../Global/Global";


const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector(state => state.auth);


    useEffect(() => {
        if (auth.isAuthenticated) {
            navigate('/dashboard');
        }
    }, [auth]);

    const [loader, setLoader] = useState(false);
    const [user, setUser] = useState({
        email: '',
        password: ''
    })

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    const onFormSubmit = (e) => {
        e.preventDefault();
        setLoader(true);
        dispatch(loginUser(user, setLoader));
    }

    return (
        <>
            <TitleBar title="Login" />
            <Alert />
            <header className="loginHeader">
                <div className="container">
                    <div className="loginLogo">
                        {/* <img src={logo} alt="" /> */}
                        <h1 style={{ color: "white" }}>{appName}</h1>
                    </div>
                </div>
            </header>

            <div className="login-container">
                <div className="container full-height-container">
                    <div className="row full-height-row align-items-center">
                        <div className="col-lg-6">
                            <div className="login-container-left">
                                <h2>Welcome <span>Back!</span></h2>
                                <p>Solve Your Business Problems in a Snap with A.I. Automation for Effortless Solutions.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="login-container-right">
                                <div className="login-container-right-main">
                                    <h2><span>Login</span> to Your Account Now</h2>
                                    <form method="post" onSubmit={(e) => onFormSubmit(e)}>
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input type="email" name="email" className="form-control"
                                                placeholder="Email Address" required
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Password</label>
                                            <input
                                                type="password"
                                                name="password"
                                                className="form-control"
                                                placeholder="************" required
                                                onChange={(e) => onInputChange(e)}
                                                maxLength={32}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <button type="submit" className="btn btn-block btn-primary themeBtn" disabled={loader}>
                                                {loader ? <i className="fa fa-spinner fa-spin mr-2" /> : ''} Sign in {appName}
                                            </button>
                                        </div>

                                        <div className="form-group">
                                            <p className="forgotLink">Forgot your account details? <Link to="/forget-password" className="text-center "> Click here</Link></p>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <LoginFooter />

        </>
    )
}

export default Login;

